<template>
<div class="grid mt-4">	

<div class="col-12 ">

<span class="p-float-label">
<Dropdown :filter="true"  v-model="$store.state.calculations.selectednode.data.selected_flow_id" :options="flows" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" :id="$store.state.calculations.selectednode.id" @change="flowSelected"/>
<label :for="$store.state.calculations.selectednode.id" class="text-primary">Seçili Aşama</label>
</span>
</div>

<div class="col-12 mt-4" v-if="projectperiods.length">

<span class="p-float-label">
<Dropdown :filter="true"  v-model="$store.state.calculations.selectednode.data.period_id" :options="projectperiods" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" id="period"  @change="addNewItem"/>
<label for="period" class="text-primary">Dönem</label>
</span>
</div>

<div class="col-12 mt-4" v-else style="height:42px">

</div>

<div class="col-12 mt-4" >

<h4 class="text-primary">Ekli Aşamalar</h4><hr>
<p v-for="item in $store.state.calculations.selectednode.data.selected_flows" class="mb-3 mt-1">
  
<RemovableChip :item="item"  @removeItem="removeItem"></RemovableChip>



</p>

</div>




</div>
</template>

<script>
import RemovableChip from "./RemovableChip"
export default {

  name: 'FlowsNodeData',
  props:["flows"],
  components:{RemovableChip},

  data () {
    return {
    	statuses:[
    		{name:"Oluşturuldu",id:"created"},
        {name:"Görüntülendi",id:"viewed"},
    		{name:"Başlandı",id:"started"},
        {name:"Değerlendirmede",id:"under_review"},
        {name:"Tamamlandı",id:"finished"},
        {name:"Düzeltme Talep Edildi",id:"correction_requested"},
        {name:"İptal Edildi",id:"canceled"},
    		{name:"Silindi",id:"deleted"},
    	],
    	include_options:[
        {name:"Aşamaya Dahil",value:"included"},
        {name:"Aşamaya Dahil Değil",value:"notincluded"},
      ],
      projectperiods:[],
    }
  },
  computed:{
    period()
    {
      if(this.$store.state.calculations.selectednode.data.period_id)
      {
        this.getProjectPeriods()
        return this.$store.state.calculations.selectednode.data.period_id
      }
    }
  },
  methods:{
    async removeItem(stack_id,type)
    {
      console.log(stack_id)
      console.log(type)
      let node = this.sanitizeArray(this.$store.state.calculations.selectednode)
      let nodes = this.sanitizeArray(this.$store.state.calculations.nodes)
      console.log(node.data.selected_flows)
      node.data.selected_flows = node.data.selected_flows.filter((item)=>{return item.stack_id !== stack_id})
      let node_ind =  nodes.findIndex((item)=>{return item.id  == node.id })
      nodes[node_ind] = node
      this.$store.dispatch('calculations/setNodes',nodes)
      this.$store.dispatch('calculations/setSelectedNode',node)
    },
    addNewItem()
    {
      let ind = this.$store.state.calculations.selectednode.data.selected_flows.findIndex((item)=>{
        return item.id == this.$store.state.calculations.selectednode.data.selected_flow_id && item.period_id == this.$store.state.calculations.selectednode.data.period_id
      })
      if(ind==-1)
      {
        let obj = {
          stack_id:this.generateId(),
          id:this.$store.state.calculations.selectednode.data.selected_flow_id,
          period_id:this.$store.state.calculations.selectednode.data.period_id,
          type:"flow"
        }
        this.$store.state.calculations.selectednode.data.selected_flows.push(obj)
      }
      else
      {
        this.showMessage("error","Bu aşama listede mevcut.","")
      }
      
    },
    testStatuses()
    {      
      let nodes = this.$store.state.calculations.nodes
      let selectednode_ind = nodes.findIndex((item)=>{return item.id == this.$store.state.calculations.selectednode.id})
      nodes[selectednode_ind] = this.$store.state.calculations.selectednode
      this.$store.dispatch('calculations/setNodes',nodes)
    },
    flowSelected()
    {
      this.getProjectPeriods()
    },
    async getProjectPeriods()
    {
      this.projectperiods = await this.generalApiGetWithoutLoader("flow_projectperiods/"+this.$store.state.calculations.selectednode.data.selected_flow_id)
    },
  }
}
</script>

<style lang="css" scoped>
</style>